import Index from "./index.vue"

export default [
  {
    path: "billing",
    name: "settings-billing",
    component: Index,
    title: "Billing",
  },
]
